<div class="subscribe-container" [style.backgroundColor]="backgroundColor">
    <div class="text-container">
        <h2>{{ 'resources.emptyListTitle' | translate }}</h2>
    </div>
    <div class="text-container">
       <p class="primary-text">{{ 'resources.emptyListBodyBefore' | translate }} <b>{{ 'resources.emptyListBodyBold' | translate }}</b>{{ 'resources.emptyListBodyAfter' | translate }}</p>
    </div>
    <div>
        <img class="subscribe-image" src="assets/images/book-lover.png" alt="Liste vide">
    </div>
</div>
